import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexType } from "../model/IndexType";
import IndexTypeMapper from "../service/IndexTypeMapper";
import IndexTypeParamMapper from "../service/IndexTypeParamMapper";

export default class GetAllGroupItemsInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(groupId: number) {
    return this.resource.execute(
      `${Constants.indexGroupBasePath}/${groupId}/items`,
      IndexTypeMapper,
      IndexTypeParamMapper
    );
  }
}
